import type { Suggestion } from '~/types/api'

export const SUGGEST_MIN_CHARS = 2
const DEBOUNCE_MS = 300

/** Debounced search suggestions: nothing until 2 characters, and late replies are ignored. */
export function useSearchSuggestions(query: Ref<string>) {
  const { $api } = useApi()
  const suggestions = ref<Suggestion[]>([])

  let timer: ReturnType<typeof setTimeout> | undefined
  let latest = 0

  watch(
    query,
    (q) => {
      if (import.meta.server) return
      clearTimeout(timer)
      const term = q.trim()
      if (term.length < SUGGEST_MIN_CHARS) {
        latest++
        suggestions.value = []
        return
      }
      timer = setTimeout(async () => {
        const id = ++latest
        try {
          const found = await $api<Suggestion[]>(`/api/search/suggestions?q=${encodeURIComponent(term)}`)
          if (id === latest) suggestions.value = found
        } catch {
          if (id === latest) suggestions.value = []
        }
      }, DEBOUNCE_MS)
    },
    { immediate: true },
  )

  onBeforeUnmount(() => clearTimeout(timer))

  return { suggestions }
}
